import React from "react";

/**
 * AuthLoading Component
 * Displays a loading screen during authentication initialization
 * @param {Object} props
 * @param {string} props.message - Loading message (default: "Loading...")
 * @param {string} props.subtitle - Subtitle text (default: "Initializing...")
 * @param {string} props.logo - Optional logo image source
 * @param {string} props.logoAlt - Alt text for logo (default: "Logo")
 */
const AuthLoading = ({
  message = "Loading...",
  subtitle = "Initializing...",
  logo,
  logoAlt = "Logo",
  texts = {},
}) => {
  const resolvedMessage = texts?.message || message;
  const resolvedSubtitle = texts?.subtitle || subtitle;
  const resolvedLogoAlt = texts?.logoAlt || logoAlt;

  return (
    <main className="flex min-h-dvh min-h-screen items-center justify-center bg-[var(--od-ink-950)] px-4 py-8 text-[var(--od-white)]">
      <div
        className="w-full max-w-sm rounded-[var(--od-radius-panel)] border border-[var(--od-ink-600)] bg-[var(--od-ink-900)] px-6 py-8 text-center shadow-[var(--od-shadow-1)]"
        role="status"
        aria-live="polite"
        aria-atomic="true"
        aria-busy="true"
      >
        {logo && (
          <div className="mx-auto mb-7 flex min-h-8 items-center justify-center">
            <img
              className="h-7 w-auto max-w-full min-w-[120px] animate-pulse motion-reduce:animate-none"
              src={logo}
              alt={resolvedLogoAlt}
            />
          </div>
        )}

        <div className="flex min-h-8 items-center justify-center gap-2">
          <span
            aria-hidden="true"
            className="h-6 w-6 shrink-0 animate-spin rounded-full border-2 border-[var(--od-ink-600)] border-t-[var(--od-blue-500)] motion-reduce:animate-none"
          />
          <span className="text-lg font-normal text-[var(--od-white)]">
            {resolvedMessage}
          </span>
        </div>

        <p className="mt-4 min-h-5 text-sm text-[var(--od-ink-300)]">
          {resolvedSubtitle}
        </p>
      </div>
    </main>
  );
};

export default AuthLoading;
